{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Crash",
  "alternateName": [
    "csgo crash", "cs go crash", "cs2 crash", "crash cs go", "cs go crash gambling",
    "csgo crash gambling", "csgo crash game", "cs2 crash game", "csgo crash site",
    "cs2 crash site", "cs go crash game", "crash game cs go", "crash cs go skins"
  ],
  "description": "A multiplier-based betting game where players must cash out before the crash.",
  "url": "https://6cs.fail/en/crash"
}
